module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_6_A_25.6076c7cf.mp3";